<template>
  <TransitionRoot as="template" :show="props.open">
    <Dialog
      as="div"
      class="fixed z-50 w-screen h-screen overflow-hidden top-0 left-0"
      @close="closeModal"
      :open="props.open"
    >
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        />
      </TransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div
          class="flex justify-center p-4 text-center mt-36 sm:items-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
            >
              <div class="" v-if="!formSubmitted">
                <div class="mt-3 sm:mt-5">
                  <DialogTitle
                    as="h3"
                    class="text-base font-semibold leading-6 text-gray-900"
                    >Product Feature Subscription (One-Time)</DialogTitle
                  >
                  <div class="mt-2">
                    <p class="text-xl text-gray-500">Workout Program</p>
                  </div>
                  <!-- active badge -->

                  <span
                    class="inline-flex mt-4 items-center gap-x-1.5 rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700"
                  >
                    <svg
                      class="h-1.5 w-1.5 fill-green-500"
                      viewBox="0 0 6 6"
                      aria-hidden="true"
                    >
                      <circle cx="3" cy="3" r="3" />
                    </svg>
                    Active
                  </span>
                </div>
                <!-- Buttons -->
                <div
                  class="mt-5 sm:mt-10 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-5"
                >
                  <button
                    type="button"
                    class="inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 sm:col-start-2"
                  >
                    Cancel Product
                  </button>
                  <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="closeModal"
                  >
                    Close
                  </button>
                </div>
              </div>

              <!-- credit card successfully changed -->
              <!-- <div class="mx-auto" v-if="formSubmitted">
                <div
                  class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100"
                >
                  <CheckIcon
                    class="h-6 w-6 text-green-600"
                    aria-hidden="true"
                  />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle
                    as="h3"
                    class="text-base font-semibold leading-6 text-gray-900"
                    >Payment Method Successfully Updated</DialogTitle
                  >
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      This payment method will be used for app access, and all
                      future in-app purchases.
                    </p>
                  </div>
                </div>
                <div class="mt-5 sm:mt-6">
                  <button
                    type="button"
                    class="inline-flex w-full justify-center rounded-md bg-[#2d8bffce] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#2d8bff81] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2d8bffce]"
                    @click=""
                  >
                    Go back to dashboard
                  </button>
                </div>
              </div> -->
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue';
import { } from '@heroicons/vue/24/outline';

// Define the open prop
const props = defineProps({
  open: Boolean
});

// Define the emit function
const emit = defineEmits(['update:open']);

// Function to close the modal
const closeModal = () => {
  emit('update:open', false);
  // formSubmitted.value = false;
};
</script>
